import { Modal, Button, Typography, Icon } from "@/components/atoms";

interface PreSimulationModalProps {
  open: boolean;
  onClose: () => void;
  onGoToTesting: () => void;
}

export const PreSimulationModal = ({ open, onClose, onGoToTesting }: PreSimulationModalProps) => {
  const handleGoToTesting = () => {
    onGoToTesting();
    onClose();
  };

  return (
    <Modal open={open} onClose={onClose} className="max-w-md px-[30px] pb-14 pt-12">
      <div className="flex flex-col items-center justify-start gap-4">
        <div className="relative flex size-20 items-center justify-center rounded-full bg-primary-light">
          <Icon name="iconsax-sparkle" isCustom size="xl" className="text-primary" />
        </div>

        <Typography variant="h3" className="text-center text-neutral-dark-gray">
          Let&apos;s Make Sure Everything Works
        </Typography>

        <Typography variant="paragraph" className="text-center text-neutral-dark-gray">
          Add real profiles and run a test booking to make sure your settings work as expected—then we&apos;ll continue setting up the rest
          of the platform
        </Typography>

        <Button variant="primary" className="w-full" onClick={handleGoToTesting}>
          Go to Testing
        </Button>
      </div>
    </Modal>
  );
};
